import { formatWebDate, formatPrettyDate, getDateAtMidnight } from '@utils/data/date-time'

export const state = {
  dateRange: {
    start: new Date().getTime(),
    end: new Date().setDate(new Date().getDate() + 1),
  },

  dateRangeInsights: {
    start: getDateAtMidnight(new Date()),
    end: getDateAtMidnight(new Date().setDate(new Date().getDate() + 1)),
  },

  dateRangeDays: 1,

  device: {
    name: null,
    group: null,
    showRunning: true,
    showIdle: true,
    searchGroup: false,
  },

  shiftPatternName: null,

  activityChangedFilter: null,

  availableInsightsFilters: {
    shifts: [],
  },
}

export const getters = {
  dateRangeFilters(state) {
    return state.dateRange
  },

  dateRangeInsightsFilters(state) {
    return {
      start: getDateAtMidnight(
        new Date().setDate(new Date(state.dateRangeInsights.start).getDate())
      ),
      end: getDateAtMidnight(
        new Date().setDate(new Date(state.dateRangeInsights.end).getDate())
      ),
    }
  },

  dateRangeDaysFilters(state) {
    return state.dateRangeDays
  },

  dateRangeReadableFilters(state) {
    return formatPrettyDate(state.dateRange.start)
  },

  dateRangeWebFilters(state) {
    return {
      start: formatWebDate(state.dateRange.start),
      end: formatWebDate(state.dateRange.end),
    }
  },

  deviceFilters(state) {
    return state.device
  },

  shiftFilters(state) {
    return state.shiftPatternName
  },

  activityChangedFilter(state) {
    return state.activityChangedFilter
  },

  availableInsightsFilters(state) {
    return state.availableInsightsFilters
  },
}

export const mutations = {
  SET_DATE_RANGE(state, dateRange) {
    state.dateRange = dateRange
  },

  SET_DATE_RANGE_INSIGHTS(state, dateRange) {
    state.dateRangeInsights = dateRange
  },

  SET_DEVICE(state, device) {
    state.device = device
  },

  SET_SHIFT_PATTERN(state, shiftPatternName) {
    state.shiftPatternName = shiftPatternName
  },

  SET_AVAILABLE_INSIGHTS_FILTERS(state, shifts) {
    state.availableInsightsFilters = {
      shifts: shifts,
    }
  },

  SET_ACTIVITY_CHANGED(state, activityChangedFilter) {
    state.activityChangedFilter = activityChangedFilter
  },
}

export const actions = {
  setDateRangeFilters({ commit, state, rootState }, { dateRange }) {
    commit('SET_DATE_RANGE', {
      start: dateRange,
      end: new Date(
        new Date(dateRange.getTime()).setDate(dateRange.getDate() + state.dateRangeDays)
      ),
    })
  },

  setDateRangeFiltersInsights({ commit, state, rootState }, { dateRange }) {
    commit('SET_DATE_RANGE_INSIGHTS', {
      start: dateRange.start,
      end: dateRange.end,
    })
  },

  setDeviceFilters({ commit, state, rootState }, { device }) {
    commit('SET_DEVICE', device)
  },

  setactivityChangedFilter({ commit, state, rootState }, { activityChanged }) {
    commit('SET_ACTIVITY_CHANGED', activityChanged)
  },

  setShiftFilters({ commit, state, rootState }, { shiftPatternName }) {
    commit('SET_SHIFT_PATTERN', shiftPatternName)
  },

  setAvailableInsightsFilters({ commit, state, rootState }, { shifts }) {
    commit('SET_AVAILABLE_INSIGHTS_FILTERS', shifts)
  },
}
